import ClearIcon from '@material-ui/icons/Clear';
import { withProps } from 'recompose';
import { withStyles } from '@material-ui/core';
import IconButton from './icon_button';

const styles = () => ({
  root: {
    '&:hover': {
      background: '#ddd',
    },
  },
  iconComponent: {},
  label: {},
});
export default withProps(() => ({ IconComponent: ClearIcon }))(
  withStyles(styles)(IconButton)
);
